import React, { Fragment } from 'react';
import NewPatient from './NewPatient';
import ViewPatient from './ViewPatient';
import ChangePassword from './ChangePassword';
import Login from './Login';
import Home from './Home';
import EditPatient from './EditPatient';
import { clientUrls, serverUrls } from '../Utils/Urls';
import { Switch, Route } from "react-router-dom";
import { getUser, getUserSuccess, getUserFailure } from '../Actions/userAction';
import axios from 'axios';
import { connect } from 'react-redux';

class Routers extends React.Component 
{
    constructor(props) {
        super(props);
        props.getUser();
    }
    render() {
        return (
            <Switch>
                {this.props.isLoggedIn?(
                    <Fragment>
                        <Route exact path={clientUrls.home} component={Home}></Route>
                        <Route exact path={clientUrls.editPatient} component={EditPatient}></Route>
                        <Route exact path={clientUrls.newPatient} component={NewPatient}></Route>
                        <Route exact path={clientUrls.viewPatient} component={ViewPatient}></Route>
                        <Route exact path={clientUrls.changePass} component={ChangePassword}></Route>
                    </Fragment>
                ):(
                    this.props.loading?null:<Route path={clientUrls.login} component={Login}></Route>
                )}
            </Switch>
        )
    }
}

const mapStateToProps = state => {
    return {
        username: state.user.username,
        isLoggedIn: state.user.isLoggedIn,
        loading: state.loadingAndError.loading
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getUser: () => {
            dispatch(getUser({loading: true}));
            axios.get(serverUrls.user).then((res)=>{
                dispatch(getUserSuccess({loading: false, username: res.data.username}));
            }).catch((err)=>{
                console.log(err);
                dispatch(getUserFailure({loading: false, errors: err.response.data}));
            })
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Routers);
